const defaults = require('./defaults');

const { elastic } = defaults;

module.exports = {
  ...defaults,
  mode: 'production',
  cacheControl: 'max-age=120',
  urlRoot: 'https://staging.ls-www.localsearch.cloud',
  serviceApiRoot: 'https://staging.services.lsapis.com.au',
  serviceGraphqlRoot: 'https://staging.services.lsapis.com.au/graphql',
  imageResizeRoot: 'https://d2xzxktm3qm7rt.cloudfront.net',
  addABusinessRoot:
    'https://forbusiness.staging.localsearch.cloud/create-profile',
  filemakerApiRoot:
    'https://fmwdz3tq57.execute-api.ap-southeast-2.amazonaws.com/staging',
  v2UrlRoot: 'https://staging.ls-www.localsearch.cloud',
  token: {
    ...defaults.token,
    cookie: { domain: '.localsearch.cloud' },
  },
  bpm: {
    baseUrl: 'https://forbusiness.staging.localsearch.cloud',
  },
  auth: {
    ...defaults.auth,
    redirectUri: 'https://staging.ls-www.localsearch.cloud/login-loader',
    returnTo: 'https://staging.ls-www.localsearch.cloud',
  },
  elastic: {
    ...elastic,
    node:
      'https://vpc-ls-services-staging-lr6p57o4tb22vihz46cv4x645i.ap-southeast-2.es.amazonaws.com',
  },
  deploy: {
    vpcSubnetIds: ['subnet-46f3a921', 'subnet-b49d4bec', 'subnet-5b93c412'],
    vpcSecurityGroupIds: ['sg-42d09625'],
  },
};
